import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
//MATERIAL-UI
import Container from '@mui/material/Container';
import { makeStyles } from 'tss-react/mui';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Collapse from '@mui/material/Collapse';
import Grid from '@mui/material/Grid';
import Sidebar from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import LinkIcon from '@mui/icons-material/Link';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import MUIDataTable from 'mui-datatables';
import Tooltip from '@mui/material/Tooltip';
//DS
import { SelectPlus, hooks, Localizacion, ConfirmDialog, ChipList, toast } from 'lib.front';
import { openMsg, loadingModal } from 'src/redux-app';

import { esquemaCampos, esquemaValidacion } from '../../utils/constants/esquemas';
import Producto from '../../../Producto';
import Presentacion from '../../../Presentacion';
import Version from '../../../Version';

//Apollo
import { cmps } from '../../utils/constants/constantes';
import { useProductoDsTienda } from '../hooks/useProductoDsTienda';
import { TextField } from '@mui/material';
import { EditProductVerDialog } from '../components/EditProductVerDialog';
import { useGestionarProductoDetalle } from '../hooks/useGestionarProductoDetalle';

const { useValidacion } = hooks;
const useStyles = makeStyles()(theme => {
   return {
      table: {
         minWidth: 650
      },
      MargTop: {
         marginTop: theme.spacing(2)
      },
      MargEnd: {
         marginEnd: theme.spacing(3)
      },
      clave: {
         widht: '30%'
      },
      list: {
         width: 250
      },
      fullList: {
         width: 'auto'
      },
      SpaceMargin: {
         margin: theme.spacing(2)
      },
      tabla: {
         width: '100%',
         overflowX: 'scroll'
      }
   };
});

const ProductoDetalle = props => {
   const dispatch = useDispatch();
   const { classes } = useStyles();
   const { getAllProductoDetalle, addProductoDetalle, deleteProductoDetalle } = useGestionarProductoDetalle();
   const [isLoading, setIsLoading] = useState(false);
   const { getAllProductosDsTienda } = useProductoDsTienda();
   const [data, setData] = useState([]);
   //Productos DsTienda
   const [productosDsTienda, setProductosDsTienda] = useState([]);
   const [productSelected, setProductSelected] = useState(null);
   //Sidebar
   const [openProducto, setOpenProducto] = useState(false);
   const [openVersion, setOpenVersion] = useState(false);
   const [openPresentacion, setOpenPresentacion] = useState(false);
   //EditDialog
   const [openEditDialog, setOpenEditDialog] = useState(false);

   //Collapse
   const [checked, setChecked] = React.useState(false);

   //Campos para los selectPlus
   const {
      campos,
      existeError: existeErrorInput,
      handleOnChange,
      inicializar,
      setCampo,
      validarTodos,
      validacionManual
   } = useValidacion(esquemaCampos, esquemaValidacion);

   const handleAgregarNuevo = () => {
      setChecked(prev => !prev);
   };

   //--Notificaciones

   //--Modal de espera
   function openWaitModal(load) {
      dispatch(loadingModal(load));
   }
   //--Modal para mensajes
   function openMsgModal(msg) {
      dispatch(openMsg(msg));
   }
   function msgError(err) {
      openMsgModal(JSON.stringify(err));
   }

   const fetchGetProductoDetalles = async () => {
      setIsLoading(true);
      const result = await getAllProductoDetalle();
      if (result) setData(result);
      setIsLoading(false);
   };

   const fetchAddProductoDetalle = async (input) => {
      setIsLoading(true);
      const result = await addProductoDetalle(input);
      if (result) {
         toast.showSucces('Los datos se actualizarón correctamente');
         fetchGetProductoDetalles();

      };
      setIsLoading(false);
   };

   const fetchDeleteProductoDetalle = async (input) => {
      setIsLoading(true);
      const result = await deleteProductoDetalle(input);
      if (result) {
         toast.showSucces('Los datos se eliminaron correctamente');
         fetchGetProductoDetalles();

      };
      setIsLoading(false);
   };

   function handleAgregar() {
      let variables = {
         codigoProducto: campos.productos.valor.value,
         codigoVersion: campos.version.valor.value,
         codigoPresentacion: campos.presentacion.valor.value,
         urlInstalador: campos.url.valor
      };
      fetchAddProductoDetalle(variables);
   }

   const fetchProductosDsTienda = async () => {
      const result = await getAllProductosDsTienda({}, ['familia', 'codigoBarra']);
      if (result) {
         setProductosDsTienda(result);
      }
   }

   //ConfirmDialog
   const [openDialog, setOpenDialog] = useState(false);
   const [IndiceEliminar, setIndiceEliminar] = useState(-1);
   function onConfirm() {
      if (IndiceEliminar != -1) {
         if (datatable[IndiceEliminar][7].length > 0) {
            toast.showError('Elimine los codigos de tienda asociados a este producto.')
         }
         else {
            const variablesEliminar = {
               codigoProducto: datatable[IndiceEliminar][0],
               codigoVersion: datatable[IndiceEliminar][1],
               codigoPresentacion: datatable[IndiceEliminar][2]
            };
            fetchDeleteProductoDetalle(variablesEliminar);
         }
      }
   }

   function onCancel() {
      setIndiceEliminar(-1);
   }

   function handleEliminar(rowIndex) {
      setOpenDialog(true);
      setIndiceEliminar(rowIndex);
   }

   function handleEditar(row) {
      const prod = {
         codigoProducto: row[1],
         producto: row[4],
         codigoVersion: row[2],
         version: row[5],
         codigoPresentacion: row[3],
         presentacion: row[6],
         idProdVerPres: row[7],
         shopCodProds: row[8],
         urlInstalador: row[9],
      }
      setOpenEditDialog(true);
      setProductSelected(prod);
   }

   const [datatable, setDatatable] = useState([]);

   // Columnas para la tabla
   const columns = [
      {
         name: '',
         options: {
            filter: false,
            sort: false,
            empty: true,
            viewColumns: false
         }
      },
      {
         name: 'codProducto',
         options: {
            filter: false,
            sort: false, //Clasificar
            empty: false, //vacio
            display: false, //Visible
            viewColumns: false
         }
      },
      {
         name: 'codVersion',
         options: {
            filter: false,
            sort: false,
            empty: false,
            display: false,
            viewColumns: false
         }
      },
      {
         name: 'codPresentacion',
         options: {
            filter: false,
            sort: false,
            empty: false,
            display: false,
            viewColumns: false
         }
      },
      {
         name: 'producto',
         label: 'PRODUCTO',
         options: {
            filter: true,
            display: 'true'
         }
      },
      {
         name: 'version',
         label: 'VERSIÓN',
         options: {
            filter: true,
            display: 'true'
         }
      },
      {
         name: 'presentacion',
         label: 'PRESENTACIÓN',
         options: {
            filter: true,
            display: 'true'
         }
      },
      {
         name: 'idProdVerPres',
         label: '',
         options: {
            filter: false,
            display: false
         }
      },
      {
         name: 'shopCodProds',
         label: 'CÓDIGOS TIENDA',
         options: {
            filter: true,
            display: 'true',
            customBodyRender: (value, tableMeta, updateValue) => {
               const codigos = value.map(p => p.shopCodProd).join(' - ');
               return codigos;

            }
         }
      },
      {
         name: 'urlInstalador',
         label: 'URL INSTALADOR',
         options: {
            filter: true,
            display: 'true',
            customBodyRender: (value, tableMeta, updateValue) => {
               return (
                  <>
                     <IconButton
                        onClick={() => window.open(value, '_blank')}
                        size="large"
                        color='primary'
                        disabled={!Boolean(value)}
                     >
                        <LinkIcon />
                     </IconButton>
                  </>
               )
            }
         }
      },
      {
         name: '',
         label: 'ACCIONES',
         options: {
            filter: false,
            display: 'true',
            viewColumns: false,
            customBodyRender: (value, tableMeta, updateValue) => {
               return (
                  <>
                     <Tooltip title="Editar">
                        <IconButton onClick={() => handleEditar(tableMeta.rowData)} size="large">
                           <EditIcon />
                        </IconButton>
                     </Tooltip>
                     <Tooltip title="Eliminar">
                        <IconButton onClick={() => handleEliminar(tableMeta.rowIndex)} size="large">
                           <DeleteIcon />
                        </IconButton>
                     </Tooltip>
                  </>
               );
            }
         }
      }
   ];

   const options = {
      filterType: 'dropdown',
      selectableRows: 'none',
      responsive: 'vertical',
      pagination: true,
      elevation: 2,
      rowsPerPage: 3,
      rowsPerPageOptions: [3, 10, 15, 100],
      rowHover: false,
      search: true,
      print: false,
      download: false,
      viewColumns: true,
      textLabels: Localizacion.muiDataTables.ES
   };

   useEffect(() => {
      if (data) {
         const datos = data;
         let tableAux = [];

         for (let k = 0; k < datos.length; k++) {
            let codPro = datos[k].codigoProducto;
            let codVer = datos[k].codigoVersion;
            let codPre = datos[k].codigoPresentacion;
            let ProAux = datos[k].producto.denominacion;
            let VerAux = datos[k].version.denominacion;
            let PreAux = datos[k].presentacion.denominacion;
            let shopCodProdsAux = datos[k].shopCodProds;
            let idProdVerPresAux = datos[k].idProdVerPres;
            let url = datos[k].urlInstalador;
            tableAux.push([codPro, codVer, codPre, ProAux, VerAux, PreAux, idProdVerPresAux, shopCodProdsAux, url]);
         }
         setDatatable(tableAux);
      }
   }, [data]);

   useEffect(() => {
      openWaitModal(isLoading);
   }, [isLoading]);

   useEffect(() => {
      fetchGetProductoDetalles();
      fetchProductosDsTienda();
   }, [])

   return (
      <Container className="containerbox" maxWidth="md">
         <Typography variant="h4">Gestionar Productos</Typography>
         <Button
            variant="contained"
            color="primary"
            onClick={handleAgregarNuevo}
            className={classes.SpaceMargin}
         >
            Agregar Nuevo
         </Button>
         <Collapse in={checked}>
            <Grid container spacing={1}>
               <Grid container item xs={12} sm={3} >
                  <Grid item xs={10}>
                     <SelectPlus
                        name={cmps.PRODUCTOS}
                        label="Productos"
                        entidad="productos"
                        campos={['codigo', 'denominacion']}
                        value={campos.productos.valor}
                        onChange={elegido => {
                           validacionManual('productos', elegido);
                        }}
                        //onChange={changePrueba}
                        genId={registro => {
                           return registro.codigo;
                        }}
                        genLabel={registro => {
                           return ` ${registro.denominacion} `;
                        }}
                        error={campos.productos.error !== ''}
                        helperText={campos.productos.error}
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                        margin="dense"
                        isClearable
                        excesoElementos
                        //permitirNuevosValores
                        recuperarOnFocus
                     />
                  </Grid>
                  <Grid item xs={2}>
                     <Tooltip title="Agregar Producto">
                        <IconButton
                           onClick={() => {
                              setOpenProducto(true);
                           }}
                           size="large"
                        >
                           <AddIcon />
                        </IconButton>
                     </Tooltip>
                  </Grid>
               </Grid>
               <Grid container item xs={12} sm={3}>
                  <Grid item xs={10}>
                     <SelectPlus
                        name={cmps.VERSION}
                        label="Versión"
                        entidad="versiones"
                        campos={['codigo', 'denominacion']}
                        value={campos.version.valor}
                        onChange={elegido => {
                           validacionManual('version', elegido);
                        }}
                        genId={registro => {
                           return registro.codigo;
                        }}
                        genLabel={registro => {
                           return ` ${registro.denominacion} `;
                        }}
                        error={campos.version.error !== ''}
                        helperText={campos.version.error}
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                        margin="dense"
                        isClearable
                        excesoElementos
                        //permitirNuevosValores
                        recuperarOnFocus
                     />
                  </Grid>
                  <Grid item xs={2}>
                     <Tooltip title="Agregar Versión">
                        <IconButton
                           onClick={() => {
                              setOpenVersion(true);
                           }}
                           size="large"
                        >
                           <AddIcon />
                        </IconButton>
                     </Tooltip>
                  </Grid>
               </Grid>
               <Grid container item xs={12} sm={3}>
                  <Grid item xs={10}>
                     <SelectPlus
                        name={cmps.PRESENTACION}
                        label="Presentación"
                        entidad="presentaciones"
                        campos={['codigo', 'denominacion']}
                        value={campos.presentacion.valor}
                        onChange={elegido => {
                           validacionManual('presentacion', elegido);
                        }}
                        genId={registro => {
                           return registro.codigo;
                        }}
                        genLabel={registro => {
                           return ` ${registro.denominacion} `;
                        }}
                        error={campos.presentacion.error !== ''}
                        helperText={campos.presentacion.error}
                        InputLabelProps={{ shrink: true }}
                        variant="outlined"
                        margin="dense"
                        isClearable
                        excesoElementos
                        recupe rarOnFocus
                     />
                  </Grid>
                  <Grid item xs={2}>
                     <Tooltip title="Agregar Presentación">
                        <IconButton
                           onClick={() => {
                              setOpenPresentacion(true);
                           }}
                           size="large"
                        >
                           <AddIcon />
                        </IconButton>
                     </Tooltip>
                  </Grid>
               </Grid>
               <Grid container item xs={12} sm={3}>
                  <Grid item xs={10}>
                     <TextField
                        name={cmps.URL}
                        label="Url Instalador"
                        variant="outlined"
                        margin="dense"
                        value={campos.url.valor}
                        onChange={
                           handleOnChange
                        }
                        error={campos.url.error !== ''}
                        helperText={campos.url.error}
                     />
                  </Grid>
               </Grid>
               <Grid item xs={12} className={classes.SpaceMargin}>
                  <Button size="small" color="primary" variant="contained" onClick={handleAgregar}>
                     Agregar
                  </Button>
               </Grid>
            </Grid>
         </Collapse>
         <MUIDataTable data={datatable} columns={columns} options={options} />
         <Sidebar
            open={openProducto}
            onClose={() => {
               setOpenProducto(false);
            }}
            anchor="right"
         >
            <Producto tipoModal={'siderbar'} />
         </Sidebar>
         <Sidebar
            open={openPresentacion}
            onClose={() => {
               setOpenPresentacion(false);
            }}
            anchor="right"
         >
            <Presentacion tipoModal={'siderbar'} />
         </Sidebar>
         <Sidebar
            open={openVersion}
            onClose={() => {
               setOpenVersion(false);
            }}
            anchor="right"
         >
            <Version tipoModal={'siderbar'} />
         </Sidebar>
         <ConfirmDialog
            titulo="¿Seguro que desea eliminar?"
            onConfirm={onConfirm}
            onCancel={onCancel}
            setOpen={() => setOpenDialog(!openDialog)}
            variant={'warning'}
            open={openDialog}
            confirmStyle={{
               backgroundColor: '#ef5350',
               color: 'white',
               '&:hover': {
                  backgroundColor: '#b71c1c'
               }
            }}
         />
         <EditProductVerDialog open={openEditDialog} onClose={() => setOpenEditDialog(false)} productoDetalle={productSelected} productostienda={productosDsTienda} loadDataTable={fetchGetProductoDetalles} />

      </Container>
   );
};
export default ProductoDetalle;
